import {useQuery} from "@tanstack/react-query";
import {useEffect} from "react";
import {getFacility} from "../services/FacilityService";
import {useLogout} from "./useLogout";

export function useFacility(id) {
    const logout = useLogout();
    const {data, isError, error, isLoading, refetch} = useQuery({
        queryKey: ["facility", id],
        queryFn: () => getFacility(id),
        enabled: !!id,
        retry: false,
    });

    useEffect(() => {
        if (isError && error.response && error.response.status) {
            if (error.response.status === 401) {
                logout();
            }
        }
    }, [isError, error, logout]);

    return {facility: data, isLoading, isError, error, refetch};
}

